import { initStore } from '@/lib/store';
import type { StoreWithSelectors } from '@/lib/store';
import { LabelType } from '@/types/streaming';

interface BaseState {
    cpLabels: LabelType[];
    setCpLabels: (cpLabels: LabelType[]) => void;
}

let useCommonStore: StoreWithSelectors<BaseState>;

const initialState = (set: (updater: (state: BaseState) => Partial<BaseState>) => void) => ({
    cpLabels: [],
    setCpLabels: (cpLabels: LabelType[]) => {
        set(() => ({ cpLabels }));
    }
});

const createCommonStore = () => {
    useCommonStore = initStore<BaseState>(initialState);
};

export { createCommonStore, useCommonStore };
